import { tss } from 'tss-react';

import { NutrientInformation } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/NutrientInformation';
import { ProductSearchInput } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/ProductSearchInput';
import { ProductTable } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/ProductTable';
import { RecipeErpViewComponentProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Index';
import * as Calculation from 'types/Recipe/Calculation';
import * as Ingredient from 'types/Recipe/Detail/ErpNew/Ingredient';

export const AccordionBody = (
	props: RecipeErpViewComponentProps & {
		mapping: Ingredient.Type;
		isLoaded: boolean;
		calculation: Calculation.Type;
	}
) => {
	const { classes } = useStyles();

	return (
		<>
			<div className={classes.suggested}>
				<ProductSearchInput
					state={props.state}
					handlers={props.handlers}
					data={props.data}
					ingredientId={props.mapping.ingredientId}
				/>

				<ProductTable
					{...props}
					productList={props.mapping.manuallySearchedProducts ?? props.mapping.products}
					ingredientId={props.mapping.ingredientId}
					segmentIndex={props.mapping.segmentIndex}
					isLoaded={props.isLoaded}
				/>
				<NutrientInformation
					{...props}
					ingredientId={props.mapping.ingredientId}
					segmentIndex={props.mapping.segmentIndex}
				/>
			</div>
		</>
	);
};

const useStyles = tss.create({
	suggested: { bpadding: '10px' },
});
